import React from "react";
import { API_BASE } from "../../admin/api";
import "./websolutions-admin.css";

export default function WebSolutionsCard({ item, onEdit, onDelete }) {
  const img = item.cover_image ? `${API_BASE}${item.cover_image}` : null;

  return (
    <article className="websolutions-card">
      <div className="websolutions-card__thumb">
        {img ? (
          <img src={img} alt={item.title} loading="lazy" />
        ) : (
          <div className="websolutions-card__thumb--empty">No Image</div>
        )}
      </div>

      <div className="websolutions-card__body">
        <div className="websolutions-card__status">
          <span
            className={`websolutions-chip ${
              item.status === "published" ? "" : "websolutions-chip--muted"
            }`}
          >
            {item.status}
          </span>
        </div>

        <h3 className="websolutions-card__title">{item.title}</h3>
        {item.excerpt && (
          <p className="websolutions-card__excerpt">{item.excerpt}</p>
        )}

        <div className="websolutions-card__actions">
          <button
            className="websolutions-btn websolutions-btn--ghost"
            onClick={() => onEdit(item)}
          >
            Edit
          </button>
          <button
            className="websolutions-btn websolutions-btn--danger"
            onClick={() => onDelete(item.id)}
          >
            Delete
          </button>
        </div>
      </div>
    </article>
  );
}
